import React from "react";
import { WelcomeCard, WeatherCard, ClockCard, DayCard, MoneyCard, EvenOddCard } from "./components";

export default function ClassroomDashboard() {
  return (
    <div className="h-screen w-screen bg-gradient-to-br from-sky-100 to-amber-100 p-2 lg:p-3 xl:p-4 flex flex-col overflow-hidden">
      <main className="flex-1 grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-3 gap-2 lg:gap-3 xl:gap-4 min-h-0 overflow-hidden">
        <WelcomeCard />
        <WeatherCard />
        <ClockCard />
        <DayCard />
        {/* <MoneyCard /> */}
        <EvenOddCard />
      </main>
      <footer className="flex-shrink-0 mt-2 lg:mt-3 text-center text-xs lg:text-sm text-slate-600 py-1">
        Tip: Hover over any card and click the settings icon to customize the controls for each activity.
      </footer>
    </div>
  );
}
